module.exports = __webpack_public_path__ + "to.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/to.svg
// module id = 850
// module chunks = 0